import {
  HeaderComp,
  type IHeaderParams,
} from '@ag-grid-community/core/dist/esm/es6/headerRendering/cells/column/headerComp'

// @ts-ignore
export class HeaderRenderer extends HeaderComp {
  private eLabel: HTMLElement | null = null
  private params: IHeaderParams | null = null

  setupSort() {
    const originalELabel = this.eLabel

    // when eLabel is null, the click event is not being handled thus sorting is disabled
    if (this.params?.context?.disableSort) {
      this.eLabel = null
    }
    super.setupSort()
    this.eLabel = originalELabel
  }
}
